type BottomSheetItemsContainerProps = {
  children: React.ReactNode;
};

const BottomSheetItemsContainer: React.FC<BottomSheetItemsContainerProps> = (props) => {
  const { children } = props;

  return <ul>{children}</ul>;
};

export default BottomSheetItemsContainer;
